var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container sync-check-page" },
    [
      _c("breadcrumb-top", { attrs: { breadcrumbConfig: _vm.dataList } }),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h2", [_vm._v("九航同步商品核对")]),
          _c("h3", [_vm._v("数据筛选")]),
          _c(
            "el-form",
            {
              ref: "searchForm",
              staticClass: "search-form",
              attrs: { inline: true, model: _vm.searchForm, size: "small" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品名称", prop: "goodsName" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "五域/九航商品名称" },
                    model: {
                      value: _vm.searchForm.goodsName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "goodsName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.goodsName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品编号", prop: "goodsNo" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入完整商品编号" },
                    model: {
                      value: _vm.searchForm.goodsNo,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "goodsNo",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.goodsNo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "SKU", prop: "sku" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请输入SKU" },
                    model: {
                      value: _vm.searchForm.sku,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.searchForm,
                          "sku",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "searchForm.sku",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "五域商品状态", prop: "wyGoodsStatus" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchForm.wyGoodsStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "wyGoodsStatus", $$v)
                        },
                        expression: "searchForm.wyGoodsStatus",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "九航商品状态", prop: "jhGoodsStatus" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchForm.jhGoodsStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "jhGoodsStatus", $$v)
                        },
                        expression: "searchForm.jhGoodsStatus",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "五域SKU状态", prop: "wySkuStatus" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchForm.wySkuStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "wySkuStatus", $$v)
                        },
                        expression: "searchForm.wySkuStatus",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "九航SKU状态", prop: "jhSkuStatus" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchForm.jhSkuStatus,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "jhSkuStatus", $$v)
                        },
                        expression: "searchForm.jhSkuStatus",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "核对结果", prop: "exceptionFlag" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.searchForm.exceptionFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "exceptionFlag", $$v)
                        },
                        expression: "searchForm.exceptionFlag",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "正常", value: 0 } }),
                      _c("el-option", { attrs: { label: "异常", value: 1 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品添加日期", prop: "createdTimeRange" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      clearable: "",
                    },
                    model: {
                      value: _vm.createdTimeRange,
                      callback: function ($$v) {
                        _vm.createdTimeRange = $$v
                      },
                      expression: "createdTimeRange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "商品更新日期", prop: "updatedTimeRange" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      clearable: "",
                    },
                    model: {
                      value: _vm.updatedTimeRange,
                      callback: function ($$v) {
                        _vm.updatedTimeRange = $$v
                      },
                      expression: "updatedTimeRange",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.search } },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: { click: _vm.reset },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "list-header" }, [
            _c("h3", [_vm._v("SKU级核对明细")]),
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", loading: _vm.exportLoading },
                    on: { click: _vm.exportAll },
                  },
                  [_vm._v("导出全部查询结果")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              attrs: {
                data: _vm.list,
                border: "",
                stripe: "",
                "max-height": "650",
                "cell-class-name": _vm.cellClassName,
                "header-cell-style": _vm.headerCellStyle,
              },
            },
            [
              _c(
                "el-table-column",
                { attrs: { label: "基础信息" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "goodsNo", label: "商品编号", width: "125" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "sku", label: "SKU", width: "155" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "exceptionDetail",
                      label: "核对结果",
                      width: "390",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.exceptionFlag !== 1
                              ? _c(
                                  "el-tag",
                                  { attrs: { type: "success", size: "mini" } },
                                  [_vm._v("正常")]
                                )
                              : scope.row.differences &&
                                scope.row.differences.length
                              ? _c(
                                  "div",
                                  { staticClass: "difference-list" },
                                  _vm._l(
                                    scope.row.differences,
                                    function (item) {
                                      return _c(
                                        "div",
                                        {
                                          key: item.field,
                                          staticClass: "difference-item",
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "difference-field" },
                                            [_vm._v(_vm._s(item.fieldName))]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "wy-value" },
                                            [
                                              _vm._v(
                                                "五域：" + _vm._s(item.wyValue)
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "difference-symbol",
                                            },
                                            [_vm._v("≠")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "jh-value" },
                                            [
                                              _vm._v(
                                                "九航：" + _vm._s(item.jhValue)
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _c(
                                  "el-tag",
                                  { attrs: { type: "danger", size: "mini" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.exceptionDetail || "异常"
                                      )
                                    ),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "el-table-column",
                { attrs: { label: "五域数据" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "wyGoodsName",
                      label: "商品名称",
                      width: "220",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wySkuName",
                      label: "SKU名称",
                      width: "150",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "wySkuNo", label: "SKU编号", width: "100" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wyGoodsStatus",
                      label: "商品状态",
                      width: "90",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.statusLabel(scope.row.wyGoodsStatus))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wySkuStatus",
                      label: "SKU状态",
                      width: "90",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.statusLabel(scope.row.wySkuStatus))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wyMarketPrice",
                      label: "市场价",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wyRetailPrice",
                      label: "零售价",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wyCostPrice",
                      label: "成本价",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wyPreCostPrice",
                      label: "前次成本价",
                      width: "100",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wyPurchasePrice",
                      label: "内购价",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wySettlementPrice",
                      label: "结算价",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wyConvertPrice",
                      label: "折算价",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wyBulkPurchasePrice",
                      label: "集采价",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wyAgentPrice",
                      label: "代理价",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wyGoodsCreatedTime",
                      label: "添加时间",
                      width: "160",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wyGoodsUpdatedTime",
                      label: "更新时间",
                      width: "160",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-table-column",
                { attrs: { label: "九航数据" } },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "jhGoodsName",
                      label: "商品名称",
                      width: "220",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jhSkuName",
                      label: "SKU名称",
                      width: "150",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "jhSkuNo", label: "SKU编号", width: "100" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jhGoodsStatus",
                      label: "商品状态",
                      width: "90",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.statusLabel(scope.row.jhGoodsStatus))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jhSkuStatus",
                      label: "SKU状态",
                      width: "90",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.statusLabel(scope.row.jhSkuStatus))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jhRecordedWySkuStatus",
                      label: "记录的五域状态",
                      width: "125",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                _vm.statusLabel(scope.row.jhRecordedWySkuStatus)
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jhMarketPrice",
                      label: "市场价",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jhRetailPrice",
                      label: "零售价",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jhPurchasePrice",
                      label: "内购价",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jhWholesalePrice",
                      label: "集采价",
                      width: "90",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jhGoodsCreatedTime",
                      label: "添加时间",
                      width: "160",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jhGoodsUpdatedTime",
                      label: "更新时间",
                      width: "160",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-pagination", {
            staticClass: "pagination",
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.page.totalNum,
              "current-page": _vm.page.pageNo,
              "page-size": _vm.page.pageSize,
              "page-sizes": [10, 20, 50, 100],
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }